













































































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { firebase } from "@/config/firebase";
import { Contrato } from "@/typings/store/plugins/easyFirestore/contratos";
import {
  CONCEPTOS_EXCEPCION,
  Excepcion,
  TIPOS_EXCEPCION,
  describirExcepcion,
  validarExcepcion,
  vigenteEn,
} from "@/helpers/excepciones";

const COLECCION = "dev/v1/excepcionesContrato";

@Component({
  computed: mapGetters({ getUsuario: "usuario/get" }),
})
export default class ExcepcionesContrato extends Vue {
  @Prop({ required: true }) readonly contrato!: Contrato;

  items: Excepcion[] = [];
  editando: Excepcion | null = null;
  cargando = false;
  guardando = false;
  error = "";
  tipos = TIPOS_EXCEPCION;
  conceptos = CONCEPTOS_EXCEPCION;
  headers = [
    { text: "Excepción", value: "descripcion", sortable: false },
    { text: "Vigencia", value: "vigencia", sortable: false },
    { text: "Autorizada por", value: "autorizadoPor", sortable: false },
    { text: "", value: "acciones", sortable: false, align: "end" },
  ];

  get db(): firebase.firestore.Firestore {
    return firebase.firestore();
  }

  get periodoActual(): string {
    return new Date().toISOString().substr(0, 7);
  }

  /** El descuento se escribe en % y se guarda como fracción. */
  get porcentaje(): number {
    return this.editando ? Math.round((Number(this.editando.valor) || 0) * 10000) / 100 : 0;
  }
  set porcentaje(v: number) {
    if (this.editando) this.editando.valor = (Number(v) || 0) / 100;
  }

  async created(): Promise<void> {
    await this.cargar();
  }

  async cargar(): Promise<void> {
    this.cargando = true;
    try {
      const codigos = Array.from(new Set([this.contrato.codigo, String(this.contrato.codigo)]));
      const snap = await this.db.collection(COLECCION).where("codigoContrato", "in", codigos).get();
      this.items = snap.docs
        .map((d) => ({ ...(d.data() as Excepcion), id: d.id }))
        .sort((a, b) => b.desde.localeCompare(a.desde));
    } finally {
      this.cargando = false;
    }
  }

  textoConcepto(e: Excepcion): string {
    if (e.tipo === "solo-variable") return "Arriendo";
    return CONCEPTOS_EXCEPCION.find((c) => c.value === e.concepto)?.text || e.concepto;
  }

  describir(e: Excepcion): string {
    return describirExcepcion(e);
  }

  vigente(e: Excepcion): boolean {
    return vigenteEn(e, this.periodoActual);
  }

  nueva(): void {
    this.error = "";
    this.editando = {
      codigoContrato: this.contrato.codigo,
      tipo: "descuento-pct",
      concepto: "ALQUILER FIJO",
      valor: 0,
      desde: this.periodoActual,
      hasta: "",
      motivo: "",
      autorizadoPor: "",
    };
  }

  editar(e: Excepcion): void {
    this.error = "";
    this.editando = { ...e };
  }

  async guardar(): Promise<void> {
    const e = this.editando;
    if (!e) return;
    if (e.tipo === "solo-variable") e.concepto = "ALQUILER FIJO";
    if (e.tipo === "no-cobrar" || e.tipo === "solo-variable") e.valor = 0;
    e.hasta = e.hasta || "";
    this.error = validarExcepcion(e);
    if (this.error) return;
    this.guardando = true;
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { id, ...datos } = e;
      const doc = {
        ...datos,
        valor: Number(datos.valor) || 0,
        motivo: datos.motivo.trim(),
        autorizadoPor: datos.autorizadoPor.trim(),
        creadoPor: datos.creadoPor || this.getUsuario?.email || "",
        creadoEn: datos.creadoEn || new Date().toISOString(),
        actualizadoPor: this.getUsuario?.email || "",
        actualizadoEn: new Date().toISOString(),
      };
      if (id) await this.db.collection(COLECCION).doc(id).set(doc);
      else await this.db.collection(COLECCION).add(doc);
      this.editando = null;
      await this.cargar();
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.error(err);
      this.error = "No se pudo guardar la excepción. Intenta de nuevo.";
    } finally {
      this.guardando = false;
    }
  }

  async eliminar(e: Excepcion): Promise<void> {
    if (!e.id || !window.confirm(`¿Eliminar la excepción "${describirExcepcion(e)}"?`)) return;
    await this.db.collection(COLECCION).doc(e.id).delete();
    await this.cargar();
  }
}
